import firebase from 'firebase'

const state = {
    categorias: [],
    Numcategorias: [],
    tags: [],
    noticias:[],
}

const actions = {
    listarCategorias({ commit }) {
        let categorias = []
        return new Promise((resolve, reject) => {
            firebase.firestore().collection('categorias').get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    let cats = doc.data()
                    cats.id = doc.id
                    categorias.push(cats)
                });
                commit('guardarCategorias', categorias)
                resolve('lista cats ok')
                reject('error')
            });
        });
    },
    listarTags({ commit }) {
        let tags = []
        return new Promise((resolve, reject) => {
            firebase.firestore().collection('tags').get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    let tag = doc.data()
                    tag.id = doc.id
                    tags.push(tag)
                });
                commit('guardarTags', tags)
                resolve('lista tag ok')
                reject('error')
            });
        });
    },
    listarCategoriaNoticias({ commit }) {
        let noticias = []
        return new Promise((resolve, reject) => {
            firebase.firestore().collection("entradas").where("categoria", "==", "noticias").get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    console.log(doc.id, " => ", doc.data());
                    let nots = doc.data()
                    nots.idFire = doc.id
                    noticias.push(nots)
                });
                commit('guardarCategoriaNoticias', noticias)
                resolve('lista cats ok')
                reject('error')
            });
        });
    },
}

const mutations = {
    guardarCategorias(state, categorias) {
        state.categorias = categorias
    },
    guardarCategoriaNoticias(state, noticias) {
        state.noticias = noticias
    },
    guardarTags(state, tags) {
        state.tags = tags
    },
}

const getters = {
    verCategorias(state) {
        return state.categorias
    },
    verTags(state) {
        return state.tags
    },
    verNoticias(state) {
        return state.noticias
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}